var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
export var ViewSection = function (_a) {
    var title = _a.title, children = _a.children, _b = _a.show, show = _b === void 0 ? true : _b;
    if (!show)
        return null;
    return (_jsxs(Box, __assign({ sx: { mb: 4 } }, { children: [_jsx(Box, __assign({ sx: {
                    borderLeft: '4px solid #1976d2',
                    pl: 2,
                    mb: 2,
                    display: 'flex',
                    alignItems: 'center'
                } }, { children: _jsx(Typography, __assign({ variant: "h6", sx: { color: '#424242', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px' } }, { children: title })) })), _jsx(Paper, __assign({ elevation: 0, sx: { border: '1px solid #E0E0E0', borderRadius: 2, p: 3, backgroundColor: '#fafafa' } }, { children: children }))] })));
};
